import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export interface DocumentModel {
    embedDocument?: boolean;
    fileDescription?: string;
    fileName: string;
    documentType: string;
    fileUrl: string;
    icon?: string;
    id: string;
    categoriesId: [];
    brandsId: [];
}

const mergeArrays = (oldDocuments: DocumentModel[], newDocuments: DocumentModel[]) => {
    const uniqueIds = new Set();
    oldDocuments.forEach(item => uniqueIds.add(item.id));

    const uniqueNewDocuments = newDocuments.filter(item => !uniqueIds.has(item.id));
    const mergedArray = oldDocuments.concat(uniqueNewDocuments);

    return mergedArray;
};

type DocumentsState = Readonly<{
    documents: any;
    isLoading?: boolean;
}>;

const initialHeaderState: DocumentsState = {
    documents: [],
    isLoading: false,
};

const reducer = {
    "KnowledgeCenter/BeginLoadDocumentss": (draft: Draft<DocumentsState>, action: { isLoading: boolean }) => {
        draft.isLoading = action.isLoading;
    },
    "KnowledgeCenter/CompletedLoadDocuments": (
        draft: Draft<DocumentsState>,
        action: { isLoading: boolean; documents: DocumentModel[];},
    ) => {
        const resultArray = mergeArrays(draft.documents, action.documents);

        draft.isLoading = action.isLoading;
        draft.documents = resultArray;
    },
};

const documents = createTypedReducerWithImmer(initialHeaderState, reducer);

(reducers as any).documents = documents;

export type xDocumentsState = {
    documents: DocumentsState;
};

type DocumentsReducers = {
    isLoading: typeof documents;
    documents: typeof documents;
};

export type DocumentsActions = Parameters<DocumentsReducers[keyof DocumentsReducers]>[1] | AnyAction;
